module.exports = __WEBPACK_EXTERNAL_MODULE_54__;


//////////////////
// WEBPACK FOOTER
// external "ReactDOM"
// module id = 54
// module chunks = 0 1